let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kTA8k")).then(() => parcelRequire('axpF6'));